export default class LogService {
  private isLoggingEnabled: boolean = false;

  constructor(enableLogging: boolean) {
    this.isLoggingEnabled = enableLogging;
  }

  public enableLogging(enable: boolean) {
    this.isLoggingEnabled = enable;
  }

  public log(message: any, ...args: any[]) {
    if (this.isLoggingEnabled) {
      if (args.length > 0) {
        // +----------+---------+--------------------+-------+
        // | SEVERITY |   CWE   | VULNERABILITY TYPE | COUNT |
        // +----------+---------+--------------------+-------+
        // | Low      | CWE-117 | Log Forging        |     1 |
        // +----------+---------+--------------------+-------+
        //console.log(message, args[0]); // Protocol:LogInjection because of args[0] param
        console.log(message, "args hidden - log manually");
      } else {
        console.log(message);
      }
    }
  }
}
